import type {
	VsmContext,
	PageConfigEntry,
	MasterPageConfigEntry,
	PageConfigFn,
	MasterPageConfigFn,
} from '@wix/thunderbolt-vsm-api-types'
import type { LightboxPageConfig, LightboxesMasterPageConfig } from '../types'
import type { PageData, PageDefinition } from '@wix/thunderbolt-becky-types'
import { name } from '../symbols'

const lightboxPageConfig: PageConfigFn<LightboxPageConfig> = ({ api }: VsmContext) => {
	const closeIconButtons = api.components.getComponentsByType('PopupCloseIconButton')
	const hasCloseIcons = Object.keys(closeIconButtons).length > 0

	const closeSiteButtons: Record<string, boolean> = {}
	const siteButtons = api.components.getComponentsByType('SiteButton')
	for (const compId of Object.keys(siteButtons)) {
		if (api.components.getCompOriginalType(compId) === 'PopupCloseTextButton') {
			closeSiteButtons[compId] = true
		}
	}
	const hasCloseSiteButtons = Object.keys(closeSiteButtons).length > 0

	const viewMode = api.env.getViewMode()
	const pageProperties = api.components.getPropsByType<PageDefinition['property']>('PageProperties')
	const popupsWithCloseOnOverlayClick: Record<string, boolean> = {}
	for (const [id, prop] of Object.entries(pageProperties)) {
		const viewProps = viewMode === 'mobile' ? prop?.mobile : prop?.desktop
		const popup = viewProps?.popup
		if (popup?.closeOnOverlayClick === true) {
			popupsWithCloseOnOverlayClick[id] = true
		}
	}
	const hasCloseOnOverlay = Object.keys(popupsWithCloseOnOverlayClick).length > 0

	if (!hasCloseIcons && !hasCloseSiteButtons && !hasCloseOnOverlay) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			closeSiteButtons,
			popupsWithCloseOnOverlayClick,
		},
	}
}

const lightboxMasterPageConfig: MasterPageConfigFn<LightboxesMasterPageConfig> = ({ api }: VsmContext) => {
	const pageItems = api.components.getDataItemsByType<PageData>('Page')
	const popupPages: Record<string, boolean> = {}
	for (const [id, pageData] of Object.entries(pageItems)) {
		if (api.page.isPopup(pageData)) {
			popupPages[id] = true
		}
	}

	const isResponsive = api.env.isResponsive()

	return {
		popupPages,
		isResponsive,
	}
}

export const pageConfig: PageConfigEntry<LightboxPageConfig> = {
	name,
	configFactory: lightboxPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}

export const masterPageConfig: MasterPageConfigEntry<LightboxesMasterPageConfig> = {
	name,
	configFactory: lightboxMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
